import React from 'react'
import './index.css'

const Loading: React.FC = () => {
  return (
    <div className="loading-mask">
      <div className="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}

export default Loading
